import React from "react";
import { Mail } from "lucide-react";
import ContactDialog from "@/components/ContactDialog";
import { COMPANY } from "@/lib/compliance";

/**
 * Email contact display. Clicking opens an in-page contact dialog that posts
 * to the same authenticated /api/inquiries pipeline used by the main form,
 * so the lead always reaches the agency mailbox — no mail client required.
 */
export default function EmailContact({
    variant = "band", // "band" | "footer" | "inline"
    testIdPrefix = "email-contact",
    defaultMessage = "",
}) {
    const email = COMPANY.email;

    if (variant === "footer") {
        return (
            <ContactDialog
                defaultMessage={defaultMessage}
                trigger={
                    <button
                        type="button"
                        data-testid={`${testIdPrefix}-link`}
                        className="text-brand-ivory underline-offset-4 hover:text-brand-gold2 hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-gold rounded-sm"
                    >
                        {email}
                    </button>
                }
            />
        );
    }

    if (variant === "inline") {
        return (
            <ContactDialog
                defaultMessage={defaultMessage}
                trigger={
                    <button
                        type="button"
                        data-testid={`${testIdPrefix}-link`}
                        className="text-brand-gold2 underline-offset-4 hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-gold rounded-sm"
                    >
                        {email}
                    </button>
                }
            />
        );
    }

    // Default — large "band" CTA used in the regional contact strip
    return (
        <ContactDialog
            defaultMessage={defaultMessage}
            trigger={
                <button
                    type="button"
                    data-testid={`${testIdPrefix}-link`}
                    aria-label={`Email ${email} (opens contact form)`}
                    className="group relative flex w-full items-center gap-4 border-t border-[rgba(212,175,55,0.2)] px-6 py-6 text-left transition-colors hover:bg-[rgba(212,175,55,0.04)] md:border-l md:border-t-0 md:px-8 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-gold focus-visible:ring-offset-2 focus-visible:ring-offset-brand-bg"
                >
                    <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-[rgba(212,175,55,0.4)] bg-[#0d1117] transition-colors group-hover:border-brand-gold group-hover:bg-[rgba(212,175,55,0.08)]">
                        <Mail
                            aria-hidden="true"
                            className="h-5 w-5 text-brand-gold2"
                        />
                    </div>
                    <div>
                        <p className="text-[10px] uppercase tracking-[0.35em] text-brand-goldSoft">
                            Email · click to message us
                        </p>
                        <p className="mt-1 font-serif text-xl text-brand-ivory transition-colors group-hover:text-brand-gold2 md:text-2xl">
                            {email}
                        </p>
                    </div>
                </button>
            }
        />
    );
}
